import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { LoginPage } from '../login/login.page';
import { LoginGuardService } from '../../services/login-guard.service';
import { PasswordReminderPage } from '../password-reminder/password-reminder.page';

const routes: Routes = [
  {
    path: '',
    canActivate: [LoginGuardService],
    runGuardsAndResolvers: 'always',
    children: [
      {
        path: '',
        component: LoginPage,
      },
      {
        path: 'login',
        component: LoginPage,
      },
      {
        path: 'password-reminder',
        component: PasswordReminderPage,
      },
    ],
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    RouterModule.forChild(routes),
  ],
  declarations: [LoginPage, PasswordReminderPage],
  providers: [],
})
export class AuthPageModule {}
